<template>
  <v-card class="elevation-2 rounded-lg my-5">
    <v-card-title class="py-4 primary--text text-center" style="font-size: 1rem;">
      <v-icon left color="primary">mdi-car-electric-outline</v-icon>
      Eléctrico
    </v-card-title>
    <v-divider></v-divider>
    <v-form ref="equipmentForm" v-model="validationsNoti.isValid">
      <v-card-text class="pa-4">
  <v-card class="mb-4 pa-3 rounded-lg" outlined>
          <div class="alert-timeline-header pa-2 primary lighten-5 text-center">
            <h3 class="text-subtitle-1 font-weight-medium mb-0">
              Selecciona el equipamiento básico a mostrar
            </h3>
          </div>
          <p class="text-center my-4">
            Todas las notificaciones las recibirá el usuario que ENTREGA/RECEPCIONA
            un vehículo, además de:
          </p>
          <v-row>
            <v-col v-for="item in items" :key="item.field" cols="12" sm="6" md="3" class="d-flex flex-column align-center mb-4">
              <v-card
                class="pa-1 rounded-lg equipment-card"
                :class="{ 'equipment-card--active': fields[item.field] && fields[item.field].is_active }"
                outlined elevation="2"
                style="width:100%;max-width:220px;"
              >
                <div class="text-center">
                  <v-icon style="font-size: 40px;">{{ item.icon }}</v-icon>
                  <p class="font-weight-medium mb-0">{{ item.label }}</p>
                </div>
              </v-card>
              <v-switch
                :input-value="fields[item.field] && fields[item.field].is_active"
                @change="updateField(item.field, $event)"
                :disabled="saving"
                inset dense
                class="mt-2"
              />
              <v-autocomplete
                :value="fields[item.field] && fields[item.field].responsibles ? fields[item.field].responsibles : []"
                @input="updateResponsibles(item.field, $event)"
                multiple
                chips
                small-chips
                :rules="validationsNoti.responsibleMov"
                :error-messages="errorsNoti.responsableMov"
                :items="userState.list"
                :loading="userState.loading"
                :search-input.sync="userState.search2"
                :disabled="loading"
                :filter="filterUsers"
                :item-text="displayTextUser"
                item-value="id"
                label="Usuario Responsable"
                prepend-inner-icon="mdi-account-key"
                hide-details="auto"
                return-object
                required outlined dense
                class="mr-2 mt-2"
              >
                <template v-slot:item="data">
                  <v-list-item-avatar class="mr-2">
                    <v-icon color="primary">mdi-account-circle</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ data.item.name }} {{ data.item.lastname }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ data.item.email }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <template v-slot:selection="data">
                  <v-chip small close @click:close="removeResponsableMov(item.field, data.item)">
                    <v-avatar left>
                      <v-icon small>mdi-account-circle</v-icon>
                    </v-avatar>
                    {{ data.item.name }} {{ data.item.lastname }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="saving || !validationsNoti.isValid"
          @click="saveDataConfig"
        >
          <v-icon left>mdi-content-save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: 'Electrico',
  props: {
    fields: Object,
    userState: Object,
    loading: Boolean,
    saving: Boolean,
    validationsNoti: Object,
    errorsNoti: Object,
    selectedResponsableMov: Array
  },
  data() {
    return {
      staticItems: [
        {
          label: 'Baliza V16',
          icon: 'mdi-car-light-high',
          field: 'equip_luz_v16'
        },
        {
          label: 'Chalecos',
          icon: 'mdi-tshirt-crew',
          field: 'equip_chaleco_reflectante'
        },
        {
          label: 'Triángulo',
          icon: 'mdi-triangle-outline',
          field: 'equip_triangulo'
        },
        {
          label: 'Cables de carga',
          icon: 'mdi-car-electric-outline',
          field: 'equip_cable_carga'
        },
        {
          label: 'Documentación',
          icon: 'mdi-file-document',
          field: 'equip_documentacion'
        }
      ]
    }
  },
  computed: {
    items() {
      const items = [...this.staticItems]
      
      // Add dynamic items for any fields not covered by static items
      if (this.fields) {
        Object.keys(this.fields).forEach(fieldKey => {
          const existsInStatic = this.staticItems.some(item => item.field === fieldKey)
          if (!existsInStatic) {
            const equipment = this.fields[fieldKey]
            items.push({
              label: equipment.name || fieldKey.replace(/^equip_/, '').replace(/_/g, ' '),
              icon: 'mdi-cog', // Default icon for dynamic items
              field: fieldKey
            })
          }
        })
      }
      
      return items
    }
  },
  methods: {
    filterUsers(item, queryText) {
      const searchText = (queryText || '').toLowerCase()
      return (
        `${item.name} ${item.lastname}`.toLowerCase().includes(searchText) ||
        item.email.toLowerCase().includes(searchText)
      )
    },
    displayTextUser(user) {
      return `${user.name} ${user.lastname}`
    },
    removeResponsableMov(fieldName, user) {
      const updatedFields = { ...this.fields }
      if (!updatedFields[fieldName] || !Array.isArray(updatedFields[fieldName].responsibles)) return
      updatedFields[fieldName].responsibles = updatedFields[fieldName].responsibles.filter(r => {
        const id = typeof r === 'object' ? r.id : r
        const userId = typeof user === 'object' ? user.id : user
        return id !== userId
      })
      this.$emit('update:fields', updatedFields)
    },
    updateField(fieldName, value) {
      const updatedFields = { ...this.fields }
      if (!updatedFields[fieldName]) updatedFields[fieldName] = {}
      updatedFields[fieldName].is_active = value
      this.$emit('update:fields', updatedFields)
    },
    updateResponsibles(fieldName, responsibles) {
      const updatedFields = { ...this.fields }
      if (!updatedFields[fieldName]) updatedFields[fieldName] = {}
      // Filtra duplicados por id
      const unique = []
      const ids = new Set()
      responsibles.forEach(r => {
        const id = typeof r === 'object' ? r.id : r
        if (!ids.has(id)) {
          ids.add(id)
          unique.push(r)
        }
      })
      updatedFields[fieldName].responsibles = unique
      this.$emit('update:fields', updatedFields)
    },
    saveDataConfig() {
      this.$emit('save-config')
    }
  }
}
</script>
<style scoped>
.alert-timeline-header {
  border-radius: 8px 8px 0 0;
}
.equipment-card--active {
  background: #e3f2fd;
  border-color: #1976d2;
  transition: background 0.2s, border-color 0.2s;
}
</style>
